import BaseModel from './BaseModel';
import AlertDefinition from './AlertDefinition';
import Equipment from './Equipment';
import * as AT from '../../components/container/attributes';

export default class Alert extends BaseModel {
  constructor({
    id,
    alertDefinition = undefined,
    equipment = undefined,
    creationDate = undefined,
  }) {
    super(id, undefined, undefined);
    this.alertDefinition = alertDefinition
      ? new AlertDefinition(alertDefinition)
      : null;
    this.equipment = equipment ? new Equipment(equipment) : null;
    this.creationDate = creationDate;
  }

  static get config() {
    return {
      addable: false,
      importable: false,
      deletable: false,
    };
  }

  get config() {
    return Alert.config;
  }

  static get baseModuleForRedirection() {
    return 'tracking-base';
  }

  get baseModuleForRedirection() {
    return Alert.baseModuleForRedirection;
  }

  static get fkName() {
    return 'alert_id';
  }

  static get apiRoute() {
    return 'alert';
  }

  static get listPageRoute() {
    return 'trackingAlerts';
  }

  get fkName() {
    return Alert.fkName;
  }

  get apiRoute() {
    return Alert.apiRoute;
  }

  get listPageRoute() {
    return Alert.listPageRoute;
  }

  static get defaultSort() {
    return {
      property: 'creationDate',
      order: 'desc',
    };
  }

  getDefaultSort() {
    return Alert.defaultSort;
  }

  static get joinAttrsKey() {
    return ['alertDefinition', 'equipment', 'creationDate'];
  }

  static get listDisplayAttrs() {
    return this.getAttributes(['alertDefinition', 'equipment', 'creationDate']);
  }

  static get allAttributes() {
    return [
      new AT.FkAlertDefinitionAttribute({
        name: 'alertDefinition',
        joinPath: [
          'alert_definition!fk_alert_alert_definition_id_alert_definition',
        ],
        tableProperties: {
          header: 'hit-app.alert.alert',
        },
      }),
      new AT.FkEquipmentAttribute({
        name: 'equipment',
        joinPath: ['equipment!fk_alert_equipment_id_equipment'],
        tableProperties: {
          header: 'hit-base.common.equipment',
        },
      }),
      new AT.DateTimeAttribute({
        name: 'creationDate',
        column: 'creation_date',
        tableProperties: {
          header: 'hit-base.common.creation-date',
        },
      }),
    ];
  }
}
